import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApWindowService } from '@ap/cdk';

/**
 * @module MijnTokensBrowserModule
 * @ngdoc service
 * @name MijnTokensBrowserNavigation
 */
@Injectable({ providedIn: 'root' })
export class MijnTokensBrowserNavigation {
    /* eslint-disable @typescript-eslint/naming-convention */
    public static START = '';
    public static PINCODE = 'pincode';
    public static VERIFY_PINCODE = 'bevestig-pincode';
    public static NAME = 'naam';
    public static DEVICE = 'apparaat';
    public static FINISHED = 'afronden';

    private activatedRoute: ActivatedRoute = null;
    private _verifyPincodeAllowed = false;
    private _nameAllowed = false;
    private _deviceAllowed = false;

    public constructor(
        private readonly router: Router,
        private readonly windowService: ApWindowService
    ) {}

    public init(activatedRoute: ActivatedRoute): void {
        this.activatedRoute = activatedRoute;
        this.resetGuards();
    }

    public internal(path: string): void {
        this.router.navigate([`./${path}`], { relativeTo: this.activatedRoute });
    }

    public external(href: string): void {
        this.windowService.location_href(href);
    }

    public open(href: string): void {
        this.windowService.open(href);
    }

    public toStart(): void {
        this.internal(MijnTokensBrowserNavigation.START);
    }

    public toPincode(): void {
        this.internal(MijnTokensBrowserNavigation.PINCODE);
    }

    public toVerifyPincode(): void {
        this.setVerifyPincodeAllowed();
        this.internal(MijnTokensBrowserNavigation.VERIFY_PINCODE);
    }

    public toName(): void {
        this.setNameAllowed();
        this.internal(MijnTokensBrowserNavigation.NAME);
    }

    public toDevice(): void {
        this.setDeviceAllowed();
        this.internal(MijnTokensBrowserNavigation.DEVICE);
    }

    public setVerifyPincodeAllowed(allow = true): void {
        this._verifyPincodeAllowed = allow;
    }

    public verifyPincodeAllowed(): boolean {
        return this._verifyPincodeAllowed;
    }

    public setNameAllowed(allow = true): void {
        this._nameAllowed = allow;
    }

    public nameAllowed(): boolean {
        return this._nameAllowed;
    }

    public setDeviceAllowed(allow = true): void {
        this._deviceAllowed = allow;
    }

    public deviceAllowed(): boolean {
        return this._deviceAllowed;
    }

    private resetGuards(): void {
        this.setVerifyPincodeAllowed(false);
        this.setNameAllowed(false);
        this.setDeviceAllowed(false);
    }
}
